exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading[data-v-1258c87f] {\n  opacity: .5;\n}\n", ""]);

// exports
